import { getFollows } from '../follows';

export const state = {
    info: null,
    comics: [],
    latest_chapters: [],
    comics_obj: {},
    chapters_obj: {},
    ratings: {},
    follows: getFollows(),
    vote_token: null,
    route: null,
};
